/**
 * Created by Kieran on 27/10/2017.
 */

import MedicationsApi from '../../api/Tracking/Medication'
import AccountApi from '../../api/Account'
import {Observable} from 'rxjs/Rx'

export default {
  data() {
    return {
      conditionSearchClass: 'conditionAutocomplete',
      conditionSearchValue: '',
      conditionSearching: false,
      conditionHelpText: 'Type a condition here',
      conditionDataSource: [],
      conditionDataSourceConfig: {
        text: 'condition_label',
        value: 'condition_id',
      }
    }
  },
  mounted() {
    let self = this;
    const conditionInputElement = $('.' + self.conditionSearchClass);
    Observable.fromEvent(conditionInputElement, 'input').map(x => x.currentTarget.value)
      .debounceTime(250)
      .subscribe(function (eventText) {
        self.handleConditionSearch(eventText)
      });
  },
  methods: {
    handleConditionSelected (value) {
      let self = this;
      let object = _.filter(self.conditionDataSource, function (o) {
        return o.condition_label === value
      });
      let checkExists = _.filter(self.conditions, function (o) {
        return o.condition_label === value
      });
      if (checkExists.length === 0) {
        self.conditions.unshift(object[0]);
        AccountApi.putUserConditions(self.conditions).then(function () {});
        self.$nextTick(function () {
          self.conditionSearchValue = '';
          self.conditionDataSource = [];
        })
      }
      else {
        self.$nextTick(function () {
          self.conditionSearchValue = '';
          self.conditionDataSource = [];
        })
      }
    },
    handleConditionSearch (value) {
      let self = this;
      self.conditionSearching = true;
      MedicationsApi.conditionsGet(value, 10)
        .then(function (response) {
          self.conditionDataSource = [];
          for (let i = 0; i < response.data.length; i++) {
            let condition = {
              'condition_id': response.data[i].ID,
              'condition_label': response.data[i].title,
              'rightIcon': 'add'
            };
            self.conditionDataSource.push(condition)
          }
          self.conditionSearching = false
        })
        .catch(function (error) {
          self.conditionDataSource = [];
          self.conditionSearching = false
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ConditionSearchMixin/index.js